if (!customElements.get('collections-slider')) {
  customElements.define(
    'collections-slider',
    class CollectionsSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderWrapper = this.querySelector('.swiper');
        this.textHovering = this.querySelectorAll('.text-hovering');
        this.sliderInstance = null;

        this.initSlider();
        this.initEventListeners();
        
        // Gestion de l'éditeur Shopify
        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.dataset.sectionId) return;
            this.switchToIndex(Number(e.target.dataset.index));
          });
        }
      }

      initSlider() {
        // Initialisation UNIQUE du slider
        const options = {
          slidesPerView: 1,
          effect: 'fade',
          fadeEffect: { crossFade: true },
          speed: 600, // Vitesse de la "fondue" (en ms)
          allowTouchMove: true,
          loop: false
        };

        // Utilisation du constructeur de ton thème
        if (window.FoxTheme && window.FoxTheme.Carousel) {
          this.sliderInstance = new window.FoxTheme.Carousel(this.sliderWrapper, options, [
            FoxTheme.Swiper.EffectFade,
          ]);
          this.sliderInstance.init();
        }
      }

      initEventListeners() {
        this.textHovering.forEach((item) => {
          item.addEventListener('mouseenter', () => {
            const index = Number(item.dataset.index);
            this.switchToIndex(index);
          });
        });
      }

      switchToIndex(index) {
        if (!this.sliderInstance || !this.sliderInstance.slider) return;

        // 1. On change de slide sans détruire le slider (gain de perf énorme)
        this.sliderInstance.slider.slideTo(index);

        // 2. On gère la classe active sur les titres
        this.textHovering.forEach((link) => {
          if (Number(link.dataset.index) === index) {
            link.classList.add('is-active');
          } else {
            link.classList.remove('is-active');
          }
        });

        // 3. Rafraîchir l'animation du bloc actif si nécessaire
        const activeSlide = this.sliderWrapper.querySelectorAll('.swiper-slide')[index];
        if (activeSlide) {
            const motionEls = activeSlide.querySelectorAll('motion-element');
            motionEls.forEach(el => {
                if(el.refreshAnimation) el.refreshAnimation();
            });
        }
      }

      disconnectedCallback() {
        // Nettoyage si la section est retirée
        if (this.sliderInstance && this.sliderInstance.slider) {
          this.sliderInstance.slider.destroy();
        }
      }
    }
  );
}